// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__JBBzO {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-full);
  font-weight: 500;
  cursor: pointer;
  transition: background 0.1s, color 0.1s;
  outline: none;
  white-space: nowrap;
  gap: calc(var(--gutter) / 2);
}

.Button_primary__9MLUH {
  background-color: var(--color-primary);
  color: var(--color-text-light);
}
.Button_primary__9MLUH:hover {
  background-color: var(--color-primary-darker);
}

.Button_secondary__sUGsj {
  background-color: var(--color-surface);
  color: var(--color-text);
}
.Button_secondary__sUGsj:hover {
  background-color: var(--color-surface-darker);
  color: var(--color-text);
}

.Button_destructive__12FM6 {
  background-color: var(--color-surface);
  color: var(--color-destructive);
}
.Button_destructive__12FM6:hover {
  background-color: var(--color-surface-darker);
  color: var(--color-destructive-darker);
}

.Button_small__jToKs {
  padding: 0.375rem 0.625rem;
}

.Button_default__e3o5q {
  padding: 0.5rem 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;AACF;;AAEA;EACE,sCAAA;EACA,8BAAA;AACF;AAAE;EACE,6CAAA;AAEJ;;AAEA;EACE,sCAAA;EACA,wBAAA;AACF;AAAE;EACE,6CAAA;EACA,wBAAA;AAEJ;;AAEA;EACE,sCAAA;EACA,+BAAA;AACF;AAAE;EACE,6CAAA;EACA,sCAAA;AAEJ;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-full);\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.1s, color 0.1s;\n  outline: none;\n  white-space: nowrap;\n  gap: calc(var(--gutter) / 2);\n}\n\n.primary {\n  background-color: var(--color-primary);\n  color: var(--color-text-light);\n  &:hover {\n    background-color: var(--color-primary-darker);\n  }\n}\n\n.secondary {\n  background-color: var(--color-surface);\n  color: var(--color-text);\n  &:hover {\n    background-color: var(--color-surface-darker);\n    color: var(--color-text);\n  }\n}\n\n.destructive {\n  background-color: var(--color-surface);\n  color: var(--color-destructive);\n  &:hover {\n    background-color: var(--color-surface-darker);\n    color: var(--color-destructive-darker);\n  }\n} \n\n.small {\n  padding: 0.375rem 0.625rem;\n}\n\n.default {\n  padding: 0.5rem .875rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__JBBzO`,
	"primary": `Button_primary__9MLUH`,
	"secondary": `Button_secondary__sUGsj`,
	"destructive": `Button_destructive__12FM6`,
	"small": `Button_small__jToKs`,
	"default": `Button_default__e3o5q`
};
export default ___CSS_LOADER_EXPORT___;
